"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service for providing custom functions / component to custom portfolios.
 */
var PortfolioDefinitionCustomValuesService = /** @class */ (function () {
    function PortfolioDefinitionCustomValuesService() {
    }
    return PortfolioDefinitionCustomValuesService;
}());
exports.PortfolioDefinitionCustomValuesService = PortfolioDefinitionCustomValuesService;
//# sourceMappingURL=portfolio-definition-custom-values.service.js.map